var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// https://www.lendi-dev.net/sign-in/email-safety-net/?returnURL=/v2/dashboard/
import * as React from 'react';
import { BYPASS_POSTCODE, getURLs, LalaSentry, Type } from '@lendi/lala-utils';
import { Status } from './types';
import { useSession } from './useSession';
import { getUserFromAPI } from './getUserFromAPI';
var useEffect = React.useEffect;
var unAuthedStatuses = [Status.Unauthenticated, Status.Expired, Status.Errored];
function shouldRedirect(status, statuses) {
    return statuses.includes(status);
}
var encodeIfNotEncoded = function (returnURL) {
    return decodeURIComponent(returnURL) === returnURL ? encodeURIComponent(returnURL) : returnURL;
};
var getURL = function (session, redirectToRegisterPage, returnURL) {
    var brand = session.brand, type = session.type, environment = session.environment, lendiGroupTeamView = session.lendiGroupTeamView;
    var authURL = redirectToRegisterPage
        ? getURLs(brand, type, environment, lendiGroupTeamView).register
        : getURLs(brand, type, environment, lendiGroupTeamView).authenticate;
    if (returnURL) {
        return "".concat(authURL, "?returnURL=").concat(encodeIfNotEncoded(returnURL));
    }
    else {
        return authURL;
    }
};
export var SessionRedirect = function (_a) {
    var _b = _a.statuses, statuses = _b === void 0 ? unAuthedStatuses : _b, children = _a.children, returnURL = _a.returnURL, redirectToRegisterPage = _a.redirectToRegisterPage, _c = _a.skipDoubleVerification, skipDoubleVerification = _c === void 0 ? false : _c, _d = _a.skipPostcodeCheck, skipPostcodeCheck = _d === void 0 ? false : _d;
    var session = useSession();
    var status = session.status, token = session.token, environment = session.environment, brand = session.brand, type = session.type, lendiGroupTeamView = session.lendiGroupTeamView;
    var _e = React.useState(false), postAuthCheckPassed = _e[0], setPostAuthCheckPassed = _e[1];
    useEffect(function () {
        if (shouldRedirect(status, statuses)) {
            window.location.assign(getURL(session, redirectToRegisterPage || false, returnURL));
        }
    }, [status]);
    useEffect(function () {
        var checkUserPostAuth = function () { return __awaiter(void 0, void 0, void 0, function () {
            var user, bypassPostCode, emailSafetyNetNeeded, postCodeNeeded, redirectURL;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!(status === Status.Authenticated)) return [3 /*break*/, 2];
                        return [4 /*yield*/, getUserFromAPI(environment, token)];
                    case 1:
                        user = _e.sent();
                        if (!user) {
                            LalaSentry.logError('Session redirect: user is not found which is a critical information to proceed');
                            setPostAuthCheckPassed(false);
                        }
                        else {
                            LalaSentry.logInfo('checkUserPostAuth v2', {
                                verifiedEmail: user.emailVerified,
                                requireDoubleVerification: user.requireDoubleVerification,
                                ownerId: user.ownerId,
                                storeId: user.storeId,
                                skipDoubleVerification: skipDoubleVerification,
                                noPostcodeRedirection: skipPostcodeCheck,
                                brand: brand,
                                lendiGroupTeamView: lendiGroupTeamView,
                                state_postcode: (_a = user.state) === null || _a === void 0 ? void 0 : _a.postcode,
                                state_emailVerification: (_b = user.state) === null || _b === void 0 ? void 0 : _b.emailVerification,
                            });
                            bypassPostCode = localStorage.getItem(BYPASS_POSTCODE) === 'true';
                            emailSafetyNetNeeded = !skipDoubleVerification && ((_c = user.state) === null || _c === void 0 ? void 0 : _c.emailVerification) === 'NEEDED';
                            postCodeNeeded = !skipPostcodeCheck && !bypassPostCode && ((_d = user.state) === null || _d === void 0 ? void 0 : _d.postcode) === 'NEEDED';
                            if (emailSafetyNetNeeded || postCodeNeeded) {
                                redirectURL = emailSafetyNetNeeded ? 'sign-in/email-safety-net/' : 'customer/suburb/';
                                LalaSentry.logInfo('redirecting from SessionRedirect', {
                                    emailSafetyNetNeeded: emailSafetyNetNeeded,
                                    postCodeNeeded: postCodeNeeded,
                                    redirectURL: redirectURL,
                                });
                                window.location.assign("".concat(getURLs(brand, type, environment, lendiGroupTeamView).origin).concat(redirectURL).concat(returnURL ? "?returnURL=".concat(encodeIfNotEncoded(returnURL)) : ''));
                            }
                            else
                                setPostAuthCheckPassed(true);
                        }
                        _e.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        var skipPostAuthCheck = (skipDoubleVerification && skipPostcodeCheck) || type !== Type.Customer;
        if (skipPostAuthCheck) {
            setPostAuthCheckPassed(true);
        }
        else {
            checkUserPostAuth().catch(function (error) {
                LalaSentry.logError('Session redirect: unable to double verify email:', { error: error });
                setPostAuthCheckPassed(false);
            });
        }
    }, [status, skipDoubleVerification, skipPostcodeCheck, type]);
    // @see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/18051
    return statuses.includes(status) || !postAuthCheckPassed ? null : React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=SessionRedirect.js.map